import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<p>{`Use the `}<inlineCode parentName="p">{`ImageContainer`}</inlineCode>{` component to contain images in documentation pages.`}</p>
<h2>{`Usage`}</h2>
<p><inlineCode parentName="p">{`ImageContainer`}</inlineCode>{` is a `}<a parentName="p" {...{
        "href": "https://mdxjs.com/blog/shortcodes"
      }}>{`shortcode`}</a>{`, meaning it's globally available in all `}<inlineCode parentName="p">{`.md`}</inlineCode>{` and `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` files. So you can use the `}<inlineCode parentName="p">{`ImageContainer`}</inlineCode>{` component in any `}<inlineCode parentName="p">{`.md`}</inlineCode>{` or `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` file without importing it.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ImageContainer>
  <img
    width="290"
    src="https://user-images.githubusercontent.com/4608155/104243682-cc166c00-5415-11eb-889b-9abe9997481a.png"
    alt="Star and Unstar buttons"
  />
</ImageContainer>
<Caption>Star and Unstar buttons</Caption>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      